var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('span',[_vm._v(" Copyright © 2021 MOON inc.")])])
}]

export { render, staticRenderFns }